// extracted by mini-css-extract-plugin
export var measureBox = "_d6-0";